import { collection, getDocs, doc, setDoc, deleteDoc } from "firebase/firestore";
import { db } from "../Firebase";

export const getDivisionCategories = async (division) => {
  try {
    const querySnapshot = await getDocs(collection(db, "division_categories"));
    const list = [];
    querySnapshot.forEach((doc) => {
      list.push({ ...doc.data(), id: doc.id });
    });
    return list.filter(cat => cat.division === division);
  } catch (error) {
    console.error("Firestore getDivisionCategories failed: ", error);
    throw error;
  }
};

export const saveDivisionCategory = async (category) => {
  try {
    const docRef = doc(db, "division_categories", category.id);
    await setDoc(docRef, category, { merge: true });
  } catch (error) {
    console.error("Firestore saveDivisionCategory failed: ", error);
    throw error;
  }
};

export const deleteDivisionCategory = async (id) => {
  try {
    const docRef = doc(db, "division_categories", id);
    await deleteDoc(docRef);
  } catch (error) {
    console.error("Firestore deleteDivisionCategory failed: ", error);
    throw error;
  }
};

export const getDivisionProducts = async (division) => {
  try {
    const querySnapshot = await getDocs(collection(db, "division_products"));
    const list = [];
    querySnapshot.forEach((doc) => {
      list.push({ ...doc.data(), id: doc.id });
    });
    return list.filter(p => p.division === division);
  } catch (error) {
    console.error("Firestore getDivisionProducts failed: ", error);
    throw error;
  }
};

export const saveDivisionProduct = async (product) => {
  try {
    const docRef = doc(db, "division_products", product.id);
    await setDoc(docRef, product, { merge: true });
  } catch (error) {
    console.error("Firestore saveDivisionProduct failed: ", error);
    throw error;
  }
};

export const deleteDivisionProduct = async (id) => {
  try {
    const docRef = doc(db, "division_products", id);
    await deleteDoc(docRef);
  } catch (error) {
    console.error("Firestore deleteDivisionProduct failed: ", error);
    throw error;
  }
};
